import { useContext } from 'react';
import TargetListContext from '../contexts/TargetListContext';

const useHasUnsavedChanges = () => {
  const { hasUnsavedChanges } = useContext(TargetListContext);
  return hasUnsavedChanges;
};

export default useHasUnsavedChanges;
